<div class="uni-dashboard">
  <div class="uni-banner" *ngIf="configDirty">
    <span>{{ 'controller.config.dirty' | translate }}</span>
    <button *ngIf="canConfigure" (click)="uploadConfig()">{{ 'controller.config.upload' | translate }}</button>
  </div>

  <div class="uni-grid">
    <app-uni-channel-card
      *ngFor="let ch of channels"
      [channel]="ch"
      [telemetry]="telemetryFor(ch.id)"
      [canConfigure]="canConfigure"
      (command)="onCommand($event)">
    </app-uni-channel-card>

    <div class="uni-empty" *ngIf="channels.length === 0">
      {{ 'uni.no_channels' | translate }}
    </div>
  </div>

  <!-- DS18B20 discovery: scan a OneWire bus, pick a ROM to add as a channel. -->
  <div class="uni-scan" *ngIf="canConfigure">
    <div class="uni-scan-row">
      <label>{{ 'uni.onewire_gpio' | translate }}
        <input type="number" [(ngModel)]="scanGpio" min="0" max="39" [placeholder]="'uni.gpio_placeholder' | translate">
      </label>
      <button (click)="scan()" [disabled]="scanGpio == null">{{ 'uni.scan' | translate }}</button>
    </div>
    <div class="uni-scan-results" *ngIf="scannedRoms.length">
      <span>{{ 'uni.found' | translate }}:</span>
      <code *ngFor="let rom of scannedRoms">{{ rom }}</code>
    </div>
  </div>
</div>
